import { gql } from '@apollo/client';
import unavailablePeriodFragment from '../unavailablePeriodFragment';
import userEventParticipationInfoCalendarViewFragment from '../userEventParticipationInfoCalendarViewFragment';

const ADD_UNAVAILABLE_PERIOD = gql`
  mutation AddUnavailablePeriod($period: UnavailablePeriodInput!, $targetUser: Int) {
    addUnavailablePeriod(period: $period, targetUser: $targetUser) {
      UnavailablePeriod {
        ...UnavailablePeriodFields
      }

      AppraiserEvent {
        Id
        TargetUserEventParticipationInfo(targetUserId: $targetUser) {
          ...UserEventParticipationInfoFields
        }
      }
    }
  }
  ${unavailablePeriodFragment}
  ${userEventParticipationInfoCalendarViewFragment}
`;

export default ADD_UNAVAILABLE_PERIOD;
